import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GridComponent, SelectionSettingsModel, ToolbarItems, PageSettingsModel } from '@syncfusion/ej2-angular-grids';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MovimientoService, MenuFuncionService, MonedaService, AlicuotaIvaService, TipoMovimientoService, TenantService, EstadoService, MedioPagoService } from '../../../../src/app/shared/services';

import { MenuFuncionCodes, Moneda, SearchAlicuotaIvaRequest, SearchMonedaRequest, AlicuotaIva, TipoMovimiento, DialogConfirmRequest, EstadoConstants, SaveMovimientoFromDocumentRequestDto, DialogCuentaSearchComponentRequestDto,
          DialogCuentaSearchComponentResponseDto, SearchMedioPagoRequest, MedioPago, GenerarMovimientoPagoDto, MovimientoAdjunto, GenerarMovimientoPagoMasivoRequestDto, SearchTipoMovimientoRequest, LocalStorageKeys, TenantFeatureFlags, DialogConfirmResponse, GenerarMovimientoDeudaDto, SearchEstadoRequest, Estado
  } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogCuentaSearchComponent } from '../cuenta/components/dialogCuentaSearch.component';

@Component({
  selector: 'app-movimientoDesdeDocumento',
  templateUrl: './movimientoDesdeDocumento.component.html',
  styles: []
})

export class MovimientoDesdeDocumentoComponent implements OnInit {

  @ViewChild('deudasGrid')
  public deudasGrid: GridComponent;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isMonedaSearching: boolean = false;
  isAlicuotaIvaSearching: boolean = false;
  isTipoMovimientoSearching: boolean = false;
  isEstadoSearching: boolean = false;
  isMedioPagoSearching: boolean = false;

  isFileAttaching: boolean = false;
  isResetting: boolean = false;
  isAnalyzing: boolean = false;
  isMovimientoDeudaSearching: boolean = false;
  isAttachmentSearching: boolean = false;
  hasAnalyzed: boolean = false;

  newFileDescripcion: string = "";

  canEdit: boolean = false;
  canView: boolean = false;
  canAddPago: boolean = false;
  canAddDeuda: boolean = false;
  canChangeState: boolean = false;

  msgError: string = "";
  // item: Movimiento;
  item: any = { Adjuntos: [] };

  alicuotaIvaList: AlicuotaIva[];
  monedaList: Moneda[];
  estadoList: Estado[];
  tipoMovimientoList: TipoMovimiento[];
  medioPagoList: MedioPago[];
  categoriaList: any[];

  tenantFeatureFlags: TenantFeatureFlags;

  operacion: number = 0;
  totalPorPagar: number = 0;
  public totalesSeleccionados: any[] = [];

  montoTotal: number = 0;

  public deudaSelectionOptions?: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private menuService: MenuFuncionService,
    private monedaService: MonedaService,
    private alicuotaIvaService: AlicuotaIvaService,
    private medioPagoService: MedioPagoService,
    private tipoMovimientoService: TipoMovimientoService,
    private tenantService: TenantService,
    private movimientoService: MovimientoService,
    private estadoService: EstadoService
  ) {
    this.deudaSelectionOptions = { persistSelection: true, type: 'Multiple', checkboxOnly: true };
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.movimientoService.clearTempFolder().subscribe(data => {
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    })

    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canView = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_ANALISIS_DOCUMENTO_MASIVO);
            if (!this.canView) {
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.onCancel();
              return false;
            }

            this.canAddPago = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_PAGO);
            this.canAddDeuda = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_DEUDA);
            this.canChangeState = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_CHANGE_STATE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    if (!this.canAddPago || !this.canAddDeuda) {
      if (this.canAddPago)
        this.onPagoClick();

      if (this.canAddDeuda)
        this.onDeudaClick();
    }
  }

  onPagoClick() {
    this.operacion = 1;

    if (this.hasAnalyzed && this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      for (var i=0; i<this.item.Adjuntos.length; i++) {
        this.item.Adjuntos[i].TipoMovimientoId = null;
        this.item.Adjuntos[i].AlicuotaIvaId = null;
      }
    }

    this.getTiposMovimientos();
    this.getMediosPago();
  }

  onDeudaClick() {
    this.operacion = -1;

    if (this.hasAnalyzed && this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      for (var i=0; i<this.item.Adjuntos.length; i++) {
        this.item.Adjuntos[i].TipoMovimientoId = null;
        this.item.Adjuntos[i].AlicuotaIvaId = null;
        this.item.Adjuntos[i].MedioPagoId = null;
      }
    }

    this.getTiposMovimientos();
    this.getAlicuotaIva();
  }

  isProcessing() {
    return (this.isSearching || this.isAnalyzing || this.isSaving || this.isResetting);
  }

  getEstados() {
    if (!this.canChangeState)
      return false;

    var r = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchMovimientoEstados(r).subscribe(data => {
      this.isEstadoSearching = false;
      this.estadoList = data?.result?.filter(f => f.Id != EstadoConstants.ESTADO_MOVIMIENTO_CANCELADO);
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMediosPago() {
    var r = new SearchMedioPagoRequest(null, null, true, "Nombre", null, null, true);
    this.isMedioPagoSearching = true;

    this.medioPagoService.search(r).subscribe(data => {
      this.isMedioPagoSearching = false;
      this.medioPagoList = data?.result;
    },
    (err: HttpErrorResponse) => {
        this.isMedioPagoSearching = false;
        this.sharedFunctions.handleError(err);
    });
  }

  getTiposMovimientos() {
    var r = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, this.operacion, null, true);
    this.isTipoMovimientoSearching = true;

    this.tipoMovimientoService.search(r).subscribe(data => {
      this.isTipoMovimientoSearching = false;
      this.tipoMovimientoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMovimientoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getAlicuotaIva() {
    this.isAlicuotaIvaSearching = true;
    var r = new SearchAlicuotaIvaRequest(null, null, true, "Nombre", null, null, null, null, true);

    this.alicuotaIvaService.search(r).subscribe((data)=>{
      this.isAlicuotaIvaSearching = false;
      this.alicuotaIvaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isAlicuotaIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onAlicuotaIvaSelect(item: any) {
    this.calcularMontos(item);
  }

  onMonedaSelect(item: any) {
    item.MonedaId = item.Moneda?.Id;
    this.calcularTotalPorPagar();
  }

  getErrorFechaMovimiento(item: any) {
    return item.FechaMovimiento == null || item.FechaMovimiento.length == 0 ? 'El campo es obligatorio' : '';
  }

  getErrorFechaVencimiento(item: any) {
    return item.FechaVencimiento == null || item.FechaVencimiento.length == 0 ? 'El campo es obligatorio' : '';
  }

  getErrorTipoMovimientoId(item: any) {
    return item.TipoMovimientoId == null || item.TipoMovimientoId <= 0 ? 'El campo es obligatorio' : '';
  }

  getErrorEstadoId(item: any) {
    return item.EstadoId == null || item.EstadoId <= 0 ? 'El campo es obligatorio' : '';
  }

  getErrorDetalle(item: any) {
    if (item.Detalle == null || item.Detalle.length == 0)
      return 'El campo es obligatorio';
    if (item.Detalle?.length > 100)
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMonedaId(item: any) {
    return item.Moneda?.Id == null || item.Moneda?.Id <= 0 ? 'El campo es obligatorio' : '';
  }

  getErrorMontoBase(item: any) {
    return item.MontoBase == null || item.MontoBase < 0 ? 'El campo es obligatorio' : '';
  }

  getErrorMonto(item: any) {
    return item.Monto == null || item.Monto < 0 ? 'El campo es obligatorio' : '';
  }

  // getErrorMontoPercepciones(item: any) {
  //   return item.MontoPercepciones == null || item.TipoMovimientoId <= 0 ? 'El campo es obligatorio' : '';
  // }

  getErrorNroComprobante(item: any) {
    return item.NroComprobante?.length > 300 ? 'Límite de 100 caracteres alcanzado' : '';
  }

  getErrorMedioPagoId(item: any) {
    if (this.operacion > 0)
      return item.MedioPagoId == null || item.MedioPagoId <= 0 ? 'El campo es obligatorio' : '';
    return ''
  }

  getErrorAlicuotaIvaId(item: any) {
    if (this.operacion < 0)
      return item.AlicuotaIvaId == null || item.AlicuotaIvaId <= 0 ? 'El campo es obligatorio' : '';
    return '';
  }

  getErrorObservacion(item: any) {
    return item.Observacion?.length > 300 ? 'Límite de 300 caracteres alcanzado' : '';
  }

  getErrorCuentaImputadaId(item: any) {
    if (this.operacion < 0)
      return item.CuentaImputadaId == null || item.CuentaImputadaId <= 0 ? 'El campo es obligatorio' : '';
    return '';
  }

  getErrorCantidadCuotas(item: any) {
    return item.CantidadCuotas > 0 ? '' : 'Debe ingresar un valor mayor a 0';
  }

  getErrorFechaInicioCuota(item: any) {
    return item.FechaInicioCuota == null || item.FechaInicioCuota.length == 0 ? 'El campo es obligatorio' : '';
  }

  getErrorDiasRepeticionCuotas(item: any) {
    return item.DiasRepeticionCuotas?.length > 5 ? 'Límite de 5 caracteres alcanzado' : '';
  }

  getErrorPorcentajeAjusteCuota(item: any) {
    return item.PorcentajeAjusteCuota >= 0 && item.PorcentajeAjusteCuota <= 100 ? '' : 'El porcentaje debe ir entre 0 y 100';
  }

  esEstadoPendiente(item: any) {
    return item.EstadoId == EstadoConstants.ESTADO_MOVIMIENTO_PENDIENTE;
  }

  onAnalizar() {
    var r = new SaveMovimientoFromDocumentRequestDto(this.item.Adjuntos?.map(s => s.UrlDocumento));
    this.isAnalyzing = true;

    this.movimientoService.generarDesdeDocumentos(r).subscribe(data => {
      this.isAnalyzing = false;
      if (data != null && data.Success && data.Result != null) {
        this.hasAnalyzed = true;
        this.item.Adjuntos = data.Result.Movimientos;

        this.calcularTotalPorPagar();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isAnalyzing = false;
      this.sharedFunctions.handleError(err, true);
    })

    this.getMonedas();
    this.getEstados();
  }

  onGuardar() {

    if (this.item.Adjuntos == null || this.item.Adjuntos.length == 0) {
      this.sharedFunctions.showMessage("Debe leer al menos un archivo para continuar con la operación", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        "Confirmación de Operación",
        "¿Seguro que desea generar los " + (this.item?.Adjuntos?.length ?? 0) + " movimientos?",
        "Sí",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        if (this.operacion > 0)
          this.doGeneracionPago();
        else
          this.doGeneracionDeuda();
      }
    });
  }

  doGeneracionPago() {

    var r = new GenerarMovimientoPagoMasivoRequestDto([], false);

    for (var i=0; i<this.item.Adjuntos.length; i++) {

      if (this.item.Adjuntos[i].CuentaImputada != null)
        this.item.Adjuntos[i].CuentaImputada.MonedaId = (this.item.Adjuntos[i].MonedaId ?? 0);

      if (this.item.Adjuntos[i].CuentaDetalle != null)
        this.item.Adjuntos[i].CuentaDetalle.MonedaId = (this.item.Adjuntos[i].MonedaId ?? 0);

      var p = new GenerarMovimientoPagoDto(
        0,
        this.item.Adjuntos[i].TipoMovimientoId,
        this.item.Adjuntos[i].CuentaImputadaId,
        this.item.Adjuntos[i].CuentaImputada,
        this.item.Adjuntos[i].CuentaDetalleId,
        this.item.Adjuntos[i].CuentaDetalle,
        this.item.Adjuntos[i].EstadoId,
        this.item.Adjuntos[i].MonedaId,
        this.item.Adjuntos[i].MedioPagoId,
        this.item.Adjuntos[i].AlicuotaIvaId,
        this.item.Adjuntos[i].FechaMovimiento,
        (this.esEstadoPendiente(this.item.Adjuntos[i]) ? this.item.Adjuntos[i].FechaVencimiento : null),
        this.item.Adjuntos[i].MontoBase,
        this.item.Adjuntos[i].MontoPercepciones,
        this.item.Adjuntos[i].Detalle,
        this.item.Adjuntos[i].Observacion,
        this.item.Adjuntos[i].NroComprobante,
        [ new MovimientoAdjunto(0, "", "", this.item.Adjuntos[i].UrlDocumento, 0) ],
        []
      );

      r.Pagos.push(p);
      // console.log('generarPago request: ', r);
    }

    this.isSaving = true;
    this.movimientoService.generarPagos(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result) {
        this.mostrarConfirmacionCierre();
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  doGeneracionDeuda() {

    var r: GenerarMovimientoDeudaDto[] = [];

    for (var i=0; i<this.item.Adjuntos.length; i++) {

      if (this.item.Adjuntos[i].CuentaImputada != null)
        this.item.Adjuntos[i].CuentaImputada.MonedaId = (this.item.Adjuntos[i].MonedaId ?? 0);

      if (this.item.Adjuntos[i].CuentaDetalle != null)
        this.item.Adjuntos[i].CuentaDetalle.MonedaId = (this.item.Adjuntos[i].MonedaId ?? 0);

      var p = new GenerarMovimientoDeudaDto(
        0,
        this.item.Adjuntos[i].TipoMovimientoId,
        this.item.Adjuntos[i].CuentaImputadaId,
        this.item.Adjuntos[i].CuentaImputada,
        this.item.Adjuntos[i].CuentaDetalleId,
        this.item.Adjuntos[i].CuentaDetalle,

        this.item.Adjuntos[i].EstadoId,
        this.item.Adjuntos[i].MonedaId,
        this.item.Adjuntos[i].AlicuotaIvaId,
        this.item.Adjuntos[i].FechaMovimiento,
        this.item.Adjuntos[i].FechaVencimiento,
        this.item.Adjuntos[i].MontoBase,
        this.item.Adjuntos[i].MontoPercepciones,

        this.item.Adjuntos[i].CantidadCuotas,
        this.item.Adjuntos[i].FechaInicioCuota,
        this.item.Adjuntos[i].DiasRepeticionCuotas,
        this.item.Adjuntos[i].PorcentajeAjusteCuota,
        this.item.Adjuntos[i].AplicarAjusteIncremental,

        false,
        null,
        null,

        this.item.Adjuntos[i].Detalle,
        this.item.Adjuntos[i].NroComprobante,
        this.item.Adjuntos[i].Observacion,

        false,
        0,

        [ new MovimientoAdjunto(0, "", "", this.item.Adjuntos[i].UrlDocumento, 0) ]
      );

      r.push(p);
      // console.log('generarPago request: ', r);
    }

    this.isSaving = true;
    this.movimientoService.generarDeudas(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result) {
        this.mostrarConfirmacionCierre();
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  mostrarConfirmacionCierre() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        "Movimiento Generado Exitosamente!",
        "Se guardaron correctamente los datos. ¿Desea cargar nuevos movimientos?",
        "Sí",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted)
        this.sharedFunctions.reloadCurrentRoute();
      else
        this.onCancel();
    });
  }

  onCancel() {
    this.location.back();
  }

  onClean() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        "Confirmación de Operación",
        "Se perderán todos los cambios no guardados hasta el momento. ¿Seguro que desea iniciar nuevamente la operación?",
        "Sí",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isResetting = true;
        this.movimientoService.clearTempFolder().subscribe(data => {
          this.isResetting = false;
          this.sharedFunctions.reloadCurrentRoute();
        },
        (err: HttpErrorResponse) => {
          this.isResetting = false;
          this.sharedFunctions.handleError(err);
          this.sharedFunctions.reloadCurrentRoute();
        })
      }
    });
  }

  onMontoBaseChange(item: any) {
    // this.formGroup.get("MontoBase")?.markAsTouched();
    this.calcularMontos(item);
  }

  calcularMontos(item: any) {
    var importeBase = parseFloat((item.MontoBase ?? 0));
    var importePercepciones = parseFloat((item.MontoPercepciones ?? 0)) * (this.operacion > 0 ? -1 : 1);

    var alicuota = this.alicuotaIvaList?.find(f => f.Id == item.AlicuotaIvaId);
    if (alicuota != null && alicuota.Id > 0)
      item.MontoAlicuotaIva = importeBase * (alicuota.Porcentaje / 100);
    else
      item.MontoAlicuotaIva = 0;

    item.Monto = importeBase + (item.MontoAlicuotaIva ?? 0) + (importePercepciones * (item.CantidadCuotas ?? 1));
    item.MontoCuota = (item.Monto * (1 + ((item.PorcentajeAjusteCuota ?? 0) / 100))) / (item.CantidadCuotas ?? 1);

    this.calcularTotalPorPagar();
  }

  calcularTotalPorPagar() {
    this.totalesSeleccionados = [];

    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      for (var i=0; i<this.item.Adjuntos.length; i++) {
        var adjunto = this.item.Adjuntos[i];
        var itemKey = (adjunto.Moneda?.Codigo ?? "?");

        var index = this.totalesSeleccionados.findIndex(v => v.key == itemKey);
        if (index == null || index < 0) {
          this.totalesSeleccionados.push({ key: itemKey, value: 0 });
          index = this.totalesSeleccionados.length - 1;
        }

        this.totalesSeleccionados[index].value += parseFloat(adjunto.Monto);
      }
    }
  }

  openAdjuntos(item: any) {
    if (item != null && item.Adjuntos != null && item.Adjuntos.length > 0) {
      for (var i=0; i<item.Adjuntos.length; i++) {
        if (item.Adjuntos[i].ArchivoBase64 != null)
          window.open(item.Adjuntos[i].ArchivoBase64);
      }
    }
    else {
      this.sharedFunctions.showMessage("No hay archivos adjuntos para visualizar", "Error");
      this.deudasGrid.refresh();
    }
  }

  onFileAttachedDelete(item: any) {
    if (item.Id > 0)
      this.onExistingFileAttachedDelete(item);
    else
      this.onNewFileAttachedDelete(item);
  }

  onExistingFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.NombreDocumento == item.NombreDocumento);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttach(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (this.item.Adjuntos == null)
        this.item.Adjuntos = [];

      for (var i=0; i<fileList.length; i++) {
        if (this.item.Adjuntos.find(f => f.NombreDocumento == fileList[i].name)) {
          setTimeout(() => {
            this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
          }, 100);
          return false;
        }
      }

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.movimientoService.uploadAttachTemp(fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            for (let i=0; i<data.Result.Archivos.length; i++) {
              if (data.Result.Archivos[i] != null) {
                this.item.Adjuntos.push(data.Result.Archivos[i]);
              }
            }
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

  openDialogCuentaImputadaSearch(item: any) {
    if (this.isProcessing())
        return;

    var monedaId = item.Moneda?.Id;
    if (monedaId == null || monedaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una moneda antes de poder seleccionar la cuenta crédito", "Error");
      return false;
    }

    //Dialog para seleccionar desde que cuenta se tomara credito excedente para realizar un pago (no aplica en deudas)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
        width: '90%',
        data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, false, false, true, true, true, monedaId, item.Moneda?.Codigo, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var cargoCuenta = this.checkCuentaImputada(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        if (item.CuentaImputadas == null)
          item.CuentaImputadas = [];

        item.CuentaImputadas.push(result.Item);

        item.CuentaImputada = result.Item;
        item.CuentaImputadaId = result.Item?.Id;
      }
    });
  }

  openDialogCuentaDetalleSearch(item: any) {
    if (this.isProcessing())
        return;

    var monedaId = item.Moneda?.Id;
    if (monedaId == null || monedaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una moneda antes de poder seleccionar la cuenta a la cual asociar la deuda", "Error");
      return false;
    }

    //Dialog para seleccionar a que cuenta se le imputa un movimiento de deuda (no se usa en pagos)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
      width: '90%',
      data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, true, true, false, false, false, monedaId, item.Moneda?.Codigo, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var cargoCuenta = this.checkCuentaDetalle(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        if (item.CuentaDetalles == null)
          item.CuentaDetalles = [];

        item.CuentaDetalles.push(result.Item);

        item.CuentaDetalle = result.Item;
        item.CuentaDetalleId = result.Item?.Id;
      }
    });
  }

  checkCuentaImputada(datosCuenta) {
    return (datosCuenta != null && ((datosCuenta.ComunidadId ?? 0) + (datosCuenta.ConsorcioId ?? 0) + (datosCuenta.UnidadFuncionalId ?? 0) > 0));
  }

  checkCuentaDetalle(datosCuenta) {
    if (datosCuenta == null)
      return false;

    if ((datosCuenta.ProveedorId ?? 0) + (datosCuenta.PersonaId ?? 0) > 0)
      return true;
    else {
      if ((datosCuenta.PersonaId ?? 0) == 0 && datosCuenta.Persona != null)
        return true;
    }

    return false;
  }
}
